import { useCallback, useEffect, useState } from 'react'

import { COLLECTIONS } from '__constants__'
import { getDocument } from 'services/api/firebase'

/**
 * It fetches a newspaper document from Firestore and returns it
 * @param newspaperId - The id that we're getting the newspaper for.
 * @returns An array with four values. The first value is the newspaper object, and the second value is a
 * boolean that indicates whether the newspaper is loading.
 */
const useGetNewspaper = (newspaperId) => {
  /* State for data */
  const [newspaper, setNewspaper] = useState(null)
  /* State for loading */
  const [loading, setLoading] = useState(!!newspaperId)
  /* State for error */
  const [error, setError] = useState(null)

  /* Fetching data */
  const getNewspaper = useCallback(async () => {
    try {
      setLoading(true)
      const document = await getDocument(COLLECTIONS.NEWSPAPERS, newspaperId)
      setNewspaper(document)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }, [newspaperId])

  useEffect(() => {
    newspaperId && getNewspaper()
  }, [newspaperId, getNewspaper])

  return [newspaper, loading, error, getNewspaper]
}

export default useGetNewspaper
